/*
Code, hiérarchie et styles liés

https://codepen.io/GreenSock/pen/LYdRQra

Modifié par Renaud R-B
*/

import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export default class BougerDrag {
  constructor(element) {
    this.element = element;

    //Breakpoint tablette
    if (window.matchMedia('(min-width: 800px)').matches) {
      //Même variables que pour la composante Modale.js
      this.deplacement = this.element.querySelector('.hub-day');
      this.modalesProjet = this.element.querySelector('.js-modale-projet');
      this.modalesProfil = this.element.querySelector('.js-modale-profil');
      this.modalesContact = this.element.querySelector('.js-modale-contact');
      this.posInit = this.element.querySelector('.js-position-init');

      //Variables du codepen
      this.bigImage = this.element.querySelector('.hub');
      this.smallImage = this.element.querySelector('#miniMap');
      this.marker = this.element.querySelector('#mapMarker');
      this.imageScale;
      this.bigDraggable = Draggable.create(this.bigImage, {
        bounds: window,
        inertia: true,
        allowContextMenu: true,
        allowEventDefault: false,
        dragClickables: false,
        edgeResistance: 0.5,
      })[0];
      this.init();
    }
  }

  init() {
    this.bougerXY();
    this.setupSizing();
    this.modalesProjet.addEventListener(
      'click',
      this.ouvrirModaleProjets.bind(this)
    );
    this.modalesProfil.addEventListener(
      'click',
      this.ouvrirModaleProfil.bind(this)
    );
    this.modalesContact.addEventListener(
      'click',
      this.ouvrirModaleContact.bind(this)
    );
    this.posInit.addEventListener('click', this.allerPosInit.bind(this));
  }

  setupSizing() {
    //this.imageScale = this.smallImage.offsetWidth / this.bigImage.offsetWidth;
    //let screenToBigRatio = window.innerWidth / this.bigImage.offsetWidth,
    //aspectRatio = window.innerWidth / window.innerHeight;
    //gsap.set(this.marker, {
    //width: screenToBigRatio * this.smallImage.offsetWidth,
    //height: (screenToBigRatio * this.smallImage.offsetWidth) / aspectRatio,
    //});
  }
  bougerXY() {
    window.addEventListener('resize', this.setupSizing);

    //Détecte si l'utilisateur utilise un écran tactile pour ajouter le paramètre allowEventDefault qui permet d'activer les boutons en mobile, mais active aussi le surlignage en drag sur desktop
    //https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
    //https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
    //function eventSurMobile() {
    if (navigator.maxTouchPoints > 1) {
      // browser supports multi-touch
      this.bigDraggable.allowEventDefault = true;
      //alert("L'utilisateur utilise un écran tactile");
    }
    //}
    // align center initially
    gsap.set(this.bigImage, {
      x: (this.bigDraggable.minX + this.bigDraggable.maxX) / 2,
      y: (this.bigDraggable.minY + this.bigDraggable.maxY) / 2,
    });
    this.bigDraggable.update();
    //eventSurMobile();
  }

  //Déplacement du viewport sur click trouvé avec l'aide de https://gsap.com/community/forums/topic/11158-draggable-update-not-working/
  //Modification du jsfiddle pour ma compréhension https://jsfiddle.net/wd8mp63o/
  ouvrirModaleProjets() {
    gsap.set(this.deplacement, { x: -3005, y: -1282.2 });
    this.bigDraggable.update();
  }
  ouvrirModaleProfil() {
    gsap.set(this.deplacement, { x: -775.2, y: -422.2 });
    this.bigDraggable.update();
  }
  ouvrirModaleContact() {
    gsap.set(this.deplacement, { x: -789.8, y: -2205.2 });
    this.bigDraggable.update();
  }
  allerPosInit() {
    gsap.set(this.deplacement, { x: -1540, y: -1284 });
    this.bigDraggable.update();
  }
}
